import React from 'react';

export default React.createContext({
    userInfo: null,
    headers: null,
    admin: false,
    setAdmin: ()=>{}
});